<template>
  <div class="card mb-3">
    <div v-if="!hasBeenSubmitted" v-bind:key="questionIndex">
      <div class="card-header bg-transparent">
        <b>
          <p class="question_color">Question
            <span class="">{{ questionIndex + 1 }}:</span>
          </p>
        </b>
      </div>
      <div class="card-body">
        <h5 class="card-title">{{que[questionIndex].questionnaire.question}}</h5>
        <div class="answer-section">
          <div class="option-section" v-if="que[questionIndex].questionnaire.type === 'BOOLEAN'">
            <div class="" v-for='(opt, index) in que[questionIndex].choices' :key="index">
              <p class="radio-option mx-2">
                <input type="radio" name="boolean_type" v-model="selected" v-bind:value="opt.id">
                <label class="mx-2">{{opt.choice}}</label>
              </p>
            </div>
          </div>
          <div class="option-section" v-if="que[questionIndex].questionnaire.type === 'TEXT'">
            <input type="text" class="input-text readonly" placeholder="Fill in the field" v-model="writtenAnswer"
                   style="min-width: 100%"/>
          </div>
          <div class="option-section" v-if="que[questionIndex].questionnaire.type === 'SINGLE_CHOICE'">
            <div v-for='(opt, index) in que[questionIndex].choices' :key="index">
              <label>
                <input type="radio" name="single" v-model="selected" v-bind:value="opt.id">&nbsp;{{opt.choice}}
              </label>
            </div>
          </div>
          <div class="option-section" v-if="que[questionIndex].questionnaire.type === 'MULTI_CHOICE'">
            <div v-for='(opt, index) in que[questionIndex].choices' :key="index">
              <label>
                <input type="checkbox" v-model="selected" v-bind:value="opt.id">&nbsp;{{opt.choice}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer bg-transparent">
        <button type="button" class="btn btn-success mx-3" v-on:click="tempPrev()" v-if="!endOfQuestion"
                :disabled="questionIndex < 1">Back</button>
        <button type="button" class="btn btn-success" v-on:click="tempNext()" v-if="!endOfQuestion"
                :disabled="questionIndex>=que.length">{{ (questionIndex>=que.length-1)?'Finish':'Next' }}</button>
        <button type="button" class="btn btn-success" v-on:click="submit(questions, index)" v-if="endOfQuestion">Submit</button>
      </div>
    </div>
    <div v-if="hasBeenSubmitted">
      <div class="card text-center">
        <div class="card-header">
          <h5>Thank you!</h5>
        </div>
        <div class="card-body">
          <p class="card-text">
            Thank you for submitting your questionnaire. You can check your scores in the Progress meter by downloading the free Chrome extension!
          </p>
        </div>
        <div class="card-footer">
          <button type="button" class="btn btn-primary" v-on:click="viewQuestionnaire">View Questionnaire</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'name: "AnswerForm"',
  data() {
    return {
      questions: '',
      choices: [],
      selectedChoice: [],
      index: 0,
      selected: [],
      writtenAnswer: [],
      answer: [],
      firstBack: false,
      endOfQuestion: false,
      hasBeenSubmitted: false,
      categoryID: null,
      //test data
      questionIndex: 0,
      que: {},
      multipleChoice: []
    };
  },
  mounted() {
    document.title = 'Starter Grower | Answer Form'
    this.categoryID = this.$route.params.id
    console.log('mounted', this.categoryID)
    // this.getQuestion()
    this.getAllQuestions()
  },
  computed: {},
  watch: {},
  methods: {
    // previousQuestion(question, index) {
    //   this.index--;
    //   let id = this.answer[this.index].questionId;
    //   let choice = this.answer[this.index].choice;
    //   this.getPreviousQuestion(id, choice)
    //   if (!this.firstBack) {
    //     this.firstBack = true
    //   }
    // },
    // next() {
    //   console.log(this.selected)
    //   const result = {
    //     questionId: this.questions.id,
    //     choice: this.selected
    //   }
    //   if (!this.firstBack) {
    //     this.answer.push(result)
    //   } else {
    //     this.answer.splice(this.index)
    //     this.answer.push(result)
    //   }
    //   this.index++
    //   this.getNextQuestion()
    // },
    // getQuestion() {
    //   let self = this;
    //   const token = localStorage.getItem("api_token")
    //   axios.get(this.$apiAdress + '/api/questionnaires/category/' + self.categoryID, {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //       Accept: 'application/json'
    //     }
    //   }).then(function (response) {
    //     console.log(response.data.data[0])
    //     self.questions = response.data.data[0].questionnaire
    //     self.choices = response.data.data[0].choices
    //     // self.getChoices(self.questions['id'])
    //   }).catch(function (error) {
    //     console.log(error);
    //   });
    // },
    // getNextQuestion() {
    //   let self = this;
    //   const token = localStorage.getItem("api_token")
    //   axios.get(this.$apiAdress + '/api/questionnaires/flow/' + self.selected, {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //       Accept: 'application/json'
    //     }
    //   }).then(function (response) {
    //     console.log(response.data)
    //     console.log('current question', response.data.data.questionnaire.id)
    //     console.log('previous question', self.answer[self.answer.length - 1].questionId)
    //     if (response.data.data.questionnaire.id !== self.answer[self.answer.length - 1].questionId){
    //       self.questions = []
    //       self.choices = []
    //       self.questions = response.data.data.questionnaire
    //       self.choices = response.data.data.choices
    //       // self.getChoices(self.questions['id'])
    //     } else {
    //       self.endOfQuestion = true
    //     }
    //   }).catch(function (error) {
    //     console.log(error);
    //   });
    // },
    // getPreviousQuestion(id, selectedChoice) {
    //   let self = this;
    //   const token = localStorage.getItem("api_token")
    //   axios.get(this.$apiAdress + '/api/questionnaires/' + id, {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //       Accept: 'application/json'
    //     }
    //   }).then(function (response) {
    //     console.log(response.data)
    //     self.questions = []
    //     self.choices = []
    //     self.questions = response.data.data
    //     self.selected = selectedChoice
    //     self.getChoices(self.questions['id'])
    //   }).catch(function (error) {
    //     console.log(error);
    //   });
    // },
    getChoices(id) {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/choices/questionnaire/' + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log(response.data)
        self.choices = response.data.data
      }).catch(function (error) {
        console.log(error);
      });
    },
    submit() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.post(this.$apiAdress + '/api/answers', {
        data: self.answer,
      } ,{
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log(response.data)
        self.hasBeenSubmitted = true
        // self.$router.push({ path: 'dashboard' });
      }).catch(function (error) {
        console.log(error)
        self.reset()
      });
    },
    viewQuestionnaire() {
      let self = this
      self.$router.push({ path: 'view-answer' });
    },

    //test functions
    tempNext() {
      let self = this
      console.log("questionnaire length", self.que.length)
      console.log("index ", self.questionIndex)

      if (this.selected.length !== 0 || this.writtenAnswer.length !== 0){
        if (self.questionIndex < self.que.length - 1) {
          const result = {
            questionId: this.que[self.questionIndex].questionnaire.id,
            choice: this.selected,
            written: this.writtenAnswer,
            type: this.que[self.questionIndex].questionnaire.type
          }

          if (!this.firstBack) {
            this.answer.push(result)
          } else {
            this.answer.splice(this.questionIndex)
            this.answer.push(result)
          }
          // this.index++
          this.questionIndex++;
          this.selected = []
          this.writtenAnswer = []
        } else {
          const result = {
            questionId: this.que[self.questionIndex].questionnaire.id,
            choice: this.selected,
            written: this.writtenAnswer,
            type: this.que[self.questionIndex].questionnaire.type
          }
          if (!this.firstBack) {
            this.answer.push(result)
          } else {
            this.answer.splice(this.questionIndex)
            this.answer.push(result)
          }
          console.log('answer',self.answer)
          self.tempSubmit()
        }
      } else {
        if (self.questionIndex < self.que.length - 1) {
          this.questionIndex++;
        } else {
          console.log('answer',self.answer)
          self.tempSubmit()
        }
      }
    },
    tempPrev() {
      let self = this
      if (self.que.length > 0)
        this.questionIndex--;
    },
    getAllQuestions() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/questionnaires/category/' + self.categoryID, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        // console.log(response.data.data)
        self.que = response.data.data
        console.log('answer form', response)
        // self.choices = response.data.data[0].choices
        // self.getChoices(self.questions['id'])
      }).catch(function (error) {
        console.log(error);
      });
    },
    tempSubmit() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.post(this.$apiAdress + '/api/answers', {
        data: self.answer,
      } ,{
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log(response.data)
        self.hasBeenSubmitted = true
      }).catch(function (error) {
        console.log(error)
        self.reset()
      });
    },
  },
};
</script>

<style scoped lang="scss">
$color-primary: #f8f8f8;
$color-secondary: #eaf0f4;
$color-blue: #4c8ce4;
$color-orange: #ff9635;
$color-red: #f06559;
$color-green: #48bf7a;
h1,
h2,
h3 {
  font-weight: 200;
}
.wid300 {
  max-width: 300px !important;
}
.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}
.question_body {
  word-break: break-all;
  color: #555;
}
.read-only-question {
  background-color: #fafafa;
}
.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}
.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}
.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}
.text-style {
  color: #969090;
  text-align: right;
}
.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}
button {
  cursor: pointer;
}
.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}
.pad-top50 {
  padding-top: 50px;
}
.form-control {
  border-radius: 2px;
}
.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}
.mar-bot20 {
  margin-bottom: 20px;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.readonly {
  background: #f7f7f7;
}
.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}
.text-color {
  color: #888;
}
.survey-name {
  color: #00baf9;
  font-size: 20px;
}
.pad-left50 {
  padding-left: 50px;
}
.branching_section {
  background-color: #f5f8fa;
  border: solid 1px #d3dfe4;
  padding: 5px 10px;
  .branching_image {
    max-width: 120px;
    max-height: 120px;
    width: 100%;
    border: 1px solid #ccc;
  }
}
.custom-btn-bg {
  background: linear-gradient(to left, #4b6fe6, #00baf9);
  color: #fff;
}
.mar-bot20 {
  margin-bottom: 20px;
}
.pad-left100 {
  padding-left: 100px;
}
.mar-bot0 {
  margin-bottom: 0px !important;
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 12px;
  margin-bottom: 12px;
}
.question_color,
input {
  color: #555;
  font-size: 16px;
}
p {
  margin: 8px 0;
}
.radio-option {
  margin: 0px;
}
.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}
.DATE-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}
.pad-top20 {
  padding-top: 20px;
}
.vertical-vue-slider {
  height: 300px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}
.horizontal-vue-slider {
  height: 8px;
  width: 100%;
}
.img-size {
  width: 100%;
  height: auto;
  float: none;
  padding: 10px 0 0;
  max-width: 120px;
  max-height: 120px;
}
label {
  font-weight: normal !important;
  word-break: break-all;
  color: #555;
}
.modal-dialog {
  width: 500px !important;
}
.width-90 {
  width: 90% !important;
}
.sb-btn-link {
  border: none;
  background: none;
  padding: 5px;
  color: #f06559;
  font-size: 14px;
  margin-top: 16px;
}
.color-blue {
  color: $color-blue;
}
.color-orange {
  color: $color-orange;
}
.color-red {
  color: $color-red;
}
.color-green {
  color: $color-green;
}
.slidecontainer {
  width: 100%;
}
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}
.slider:hover {
  opacity: 1;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #4caf50;
  cursor: pointer;
}
.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #4caf50;
  cursor: pointer;
}
.row {
  display: block;
  margin: 10px;
}
</style>
